import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { GraduationCap, Calendar, Megaphone, ArrowRight } from "lucide-react";
import FadeIn from "../../ui/FadeIn";
import SectionHeader from "../../ui/SectionHeader";

const programs = [
  {
    title: "Community Engagement Program",
    description: "Empowering youth through structured community service that builds empathy, leadership, and social responsibility.",
    icon: GraduationCap,
    to: "/cep",
    color: "from-ku-purple to-ku-violet",
    accent: "bg-ku-purple",
  },
  {
    title: "Volenteering Projects",
    description: "Kindness Jams, Dance of Kindness, nutrition drives, education outreach - hands-on projects and events bringing people together.",
    icon: Calendar,
    to: "/engagements",
    color: "from-ku-gold-dark to-ku-gold",
    accent: "bg-ku-gold",
  },
  {
    title: "Campaigns & Stories",
    description: "Project KUL, Daan Utsav, and more - campaigns that turn ordinary people into agents of change.",
    icon: Megaphone,
    to: "/project-kul",
    color: "from-ku-purple-deep to-ku-purple",
    accent: "bg-ku-purple-deep",
  },
];

const FeaturedPrograms = () => (
  <section className="ku-section bg-white relative">
    <div className="absolute inset-0 bg-noise opacity-20 pointer-events-none" aria-hidden />
    <div className="ku-container relative">
      <SectionHeader
        eyebrow="Our Programs"
        title="Making Kindness Practical"
        subtitle="Structured programs and community-driven initiatives that turn compassion into measurable impact."
      />

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {programs.map((program, i) => (
          <FadeIn key={program.title} delay={i * 0.1}>
            <Link to={program.to} className="group block h-full">
              <motion.div
                whileHover={{ y: -8, scale: 1.02 }}
                transition={{ type: "spring", stiffness: 300 }}
                className="ku-card h-full flex flex-col p-6 relative overflow-hidden"
              >
                {/* Decorative gradient corner */}
                <div className={`absolute top-0 right-0 w-24 h-24 bg-gradient-to-bl ${program.color} opacity-10 rounded-bl-[60px] transition-opacity duration-500 group-hover:opacity-20`} />

                {/* Icon */}
                <div className={`w-12 h-12 rounded-2xl bg-gradient-to-br ${program.color} flex items-center justify-center mb-5 shadow-card`}>
                  <program.icon className="w-6 h-6 text-white" />
                </div>

                {/* Content */}
                <h3 className="font-display font-bold text-ku-purple text-lg mb-3 group-hover:text-ku-purple-dark transition-colors">
                  {program.title}
                </h3>
                <p className="font-body text-gray-600 text-sm leading-relaxed flex-1 mb-4">
                  {program.description}
                </p>

                {/* Learn More */}
                <div className="flex items-center gap-2 text-ku-gold-dark font-accent font-semibold text-sm group-hover:gap-3 transition-all duration-300">
                  Learn More
                  <ArrowRight className="w-4 h-4" />
                </div>
              </motion.div>
            </Link>
          </FadeIn>
        ))}
      </div>
    </div>
  </section>
);

export default FeaturedPrograms;
